import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import { alterarStatusCorrecao } from '~/Services/Service';

const ModalAlterarStatusCorrecao = ({ show, onHide, correcao, onSalvar }) => {
  const [status, setStatus] = useState('A');
  const [saving, setSaving] = useState(false);

  const temStatusNulo = AuthStorage.temCaracteristica(
    caracteristicas.StatusNuloCorrecao
  );

  const statusAtual = correcao && correcao.status != null ? correcao.status : '';
  const atualEhNulo = statusAtual !== 'A' && statusAtual !== 'I';
  const bloqueadoPorNulo = atualEhNulo && !temStatusNulo;

  useEffect(() => {
    if (show && correcao) {
      setStatus(statusAtual || 'A');
    }
  }, [show, correcao, statusAtual]);

  const opcoes = [
    { value: 'A', label: 'Ativo' },
    { value: 'I', label: 'Inativo' },
    ...(temStatusNulo ? [{ value: '', label: 'Nulo' }] : []),
  ];

  const handleSalvar = async () => {
    if (status === statusAtual) {
      onHide();
      return;
    }
    setSaving(true);
    try {
      await alterarStatusCorrecao(correcao.codigo, status);
      toast.success('Status alterado com sucesso');
      onSalvar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao alterar status';
      toast.error(msg);
    } finally {
      setSaving(false);
    }
  };

  const statusLabel = (v) => {
    if (v === 'A') return 'Ativo';
    if (v === 'I') return 'Inativo';
    return 'Nulo';
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" size="md">
      <Modal.Header closeButton>
        <Modal.Title>Alterar Status</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {correcao && (
          <div className="mb-3 small text-muted">
            <div>
              <strong>Código:</strong> {correcao.codigo}
            </div>
            <div>
              <strong>Descrição:</strong> {correcao.descricao}
            </div>
            <div>
              <strong>Status atual:</strong> {statusLabel(statusAtual)}
            </div>
          </div>
        )}
        {bloqueadoPorNulo ? (
          <div className="text-danger small">
            Esta correção possui status Nulo. Apenas usuários com a
            característica &quot;Altera Status Nulo Correção&quot; podem
            alterá-la.
          </div>
        ) : (
          <Form.Group>
            <Form.Label className="small mb-1">Novo Status *</Form.Label>
            <Form.Control
              as="select"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              {opcoes.map((o) => (
                <option key={o.value || 'nulo'} value={o.value}>
                  {o.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleSalvar}
          disabled={saving || bloqueadoPorNulo}
        >
          {saving ? 'Salvando...' : 'Salvar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAlterarStatusCorrecao;
